import { useState } from "react";
import { BsArrowRightShort } from "react-icons/bs";
import { AiOutlineCheckCircle } from "react-icons/ai";

import styles from "./ServiceItem.module.css";
import { Card } from "../UI/Card/Card";
import UIModal from "../UI/Modal/Modal";

export const ServiceItem = ({ Icon, title, content }) => {
  const [isOpen, setIsOpen] = useState("null");

  const onOpen = () => setIsOpen(true);
  const onClose = () => setIsOpen(false);

  const titleArr = title.split(" ");
  const secondLine = titleArr.slice(1).join(" ");
  const body = ContentList(content);

  return (
    <>
      <UIModal
        header={title}
        body={body}
        isOpen={isOpen}
        closeModal={onClose}
      />
      <Card className={styles.content}>
        <Icon className={styles.icon} />
        <h3 className={styles.title}>{title} </h3>
        <button aria-label="open modal" className={styles.btn} onClick={onOpen}>
          View more <BsArrowRightShort className={styles["btn-icon"]} />
        </button>
      </Card>
    </>
  );
};

const ContentList = (content) => (
  <ul>
    {content.map((item, idx) => (
      <li key={idx} className={styles["service-item"]}>
        <span className={styles["item-icon"]}>
          <AiOutlineCheckCircle fontSize={"1rem"} />
        </span>
        <p>{item} </p>
      </li>
    ))}
  </ul>
);
